import { useMemo } from 'react'
import { MODULES, type ModuleData } from '../../../content'
import type { LearnerAccount } from '../../../accounts'

/**
 * useModuleMastery — Shared module mastery computation for parent portal
 *
 * Extracts the duplicated MODULES.map → filter(mastery>0) → sort pattern
 * from HomePage and TipsPage into a single reusable hook.
 *
 * Returns modules with mastery > 0, sorted by mastery descending.
 */
export function useModuleMastery(
  selectedChild: LearnerAccount | undefined,
  getLearnerModuleMastery: (learnerId: string, moduleId: string) => number,
): Array<{ module: ModuleData; mastery: number }> {
  return useMemo(() => {
    if (!selectedChild) return []

    return MODULES.map((module) => ({
      module,
      mastery: getLearnerModuleMastery(selectedChild.id, module.id),
    }))
      .filter((m) => m.mastery > 0)
      .sort((a, b) => b.mastery - a.mastery)
  }, [selectedChild?.id, getLearnerModuleMastery])
}
